/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Processing_Progress_LabelInputs */



/**
* | output |
* | --- |
* | "Transcription progress" |
*
* @param {Processing_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const processing_progress_label = /** @type {((inputs?: Processing_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Processing_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription progress")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transcription progress")
	if (locale === "it") return /** @type {LocalizedString} */ ("Transcription progress")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Transcription progress")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcription progress")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Transcription progress")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Transcription progress")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Transcription progress")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transcription progress")
	return /** @type {LocalizedString} */ ("Transcription progress")
});